import UUIDBase from '../UUIDBase'
import { localizeFieldName, useI18nInstance } from '@/plugins/i18n'
import Dinero, { Currency, Dinero as DineroType } from 'dinero.js'
import Pack from "@/models/inventory/Pack";
import CustomPriceType from "@/models/inventory/CustomPrice";

const { t } = useI18nInstance().global

export default class ItemCustomPrice extends UUIDBase {
    static from(json: Record<string, unknown> | ItemCustomPrice) {
        const itemCustomPrice = Object.assign(new ItemCustomPrice(), json)


        if (itemCustomPrice.salePriceAmount && itemCustomPrice.salePriceCurrency) {
            itemCustomPrice.salePriceDinero = Dinero({
                amount: itemCustomPrice.salePriceAmount,
                currency: itemCustomPrice.salePriceCurrency as Currency,
                precision: itemCustomPrice.salePricePrecision
            })
        }

        itemCustomPrice.createdAt = new Date(json.createdAt as string)
        itemCustomPrice.updatedAt = new Date(json.updatedAt as string)
        itemCustomPrice.deletedAt = json.deletedAt ? new Date(json.deletedAt as string) : undefined

        return itemCustomPrice
    }

    itemID?: string
    customPriceTypeID?: string
    customPriceType?: CustomPriceType

    salePriceAmount?: number
    salePriceCurrency?: string
    salePricePrecision?: number
    salePriceDinero?: DineroType

    disabled = false
}
